import { baseColors } from "@Constants/baseStyles"
import React, { useEffect, useState } from "react"
import { Dimensions, StyleSheet, TouchableOpacity, View } from "react-native"
import { Divider, IconButton } from "react-native-paper"
import { CustomTouchable } from "../Reminder/CustomTouchable"
import Modal from "react-native-modal"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RadioButton } from "react-native-paper"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { Spacer } from "@Components/Space"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { getSportIcon, isNumber } from "@Utils/utils"
import { MaterialCommunityIcons } from "@expo/vector-icons"

const { width, height } = Dimensions.get("screen")

export const CustomPicker = (props) => {
    const { value, data, handleChange, title } = props
    const [visible, setVisible] = useState(false)
    const [currentValue, setCurrentValue] = useState(props.value)
    const selectedLabel = currentValue ? data.filter((item) => item.id == currentValue)[0]?.label : title
    useEffect(() => {
        if (currentValue && !isNaN(currentValue)) {
            handleChange?.(currentValue)
        }
        setVisible(false)
    }, [currentValue])

    useEffect(() => {
        setCurrentValue(value)
    }, [value])

    useEffect(() => {
        if (currentValue && isNumber(currentValue)) {
            handleChange?.(currentValue)
        }
    }, [])

    return (
        <View>
            <CustomTouchable
                disabled={props.disabled}
                title={props.customLabel?.length > 0 ? props.customLabel : selectedLabel ? selectedLabel : title}
                onPress={() => setVisible(true)}
            />
            <View>
                <Modal
                    swipeDirection={["left", "right", "down"]}
                    animationOutTiming={1000}
                    animationInTiming={1000}
                    isVisible={visible}
                    collapsable
                >
                    <View
                        style={[
                            styles.containerModal,
                            props.scrollable ? { maxHeight: height / 1.5, paddingBottom: 80 } : {}
                        ]}
                    >
                        {/* <IconButton
                            rippleColor={"rgba(0,0,0,0.05)"}
                            onPress={() => setVisible(false)}
                            icon="close"
                            color={baseColors.green.primary}
                            size={35}
                            style={{ alignSelf: "flex-end" }}
                        /> */}

                        <TouchableOpacity
                            onPress={() => setVisible(false)}
                            style={{ alignSelf: "flex-end", padding: 20 }}
                        >
                            <MaterialCommunityIcons name={"close"} size={35} color={baseColors.green.primary} />
                        </TouchableOpacity>

                        <View style={{ padding: 0 }}>
                            <BreeSerifText textAlign={"center"} fontSize={18}>
                                {title}
                            </BreeSerifText>
                            {props.header && props.header}
                            <View style={{ padding: 30 }}>
                                <Spacer height={0} />
                                <CustomScrollview paddingBottom={20} paddingTop={1}>
                                    {data &&
                                        data.map((item, i) => (
                                            <View key={i}>
                                                {props.renderItem ? (
                                                    props.renderItem(
                                                        { item },
                                                        { onPress: () => setCurrentValue(item.id) }
                                                    )
                                                ) : (
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            props.onPressItem?.(item.id)
                                                            setCurrentValue(item.id)
                                                            setVisible(false)
                                                        }}
                                                        style={styles.itemContainer}
                                                    >
                                                        <RadioButton
                                                            onPress={() => {
                                                                props.onPressItem?.(item.id)
                                                                setCurrentValue(item.id)
                                                                setVisible(false)
                                                            }}
                                                            status={item.id == currentValue ? "checked" : "unchecked"}
                                                        />
                                                        <View>
                                                            {props.sport &&
                                                                props.withIcon &&
                                                                getSportIcon(item.label, baseColors.green.primary, 20)}
                                                        </View>
                                                        <OpenSansText
                                                            style={{ marginLeft: 10, marginVertical: 10 }}
                                                            fontSize={16}
                                                        >
                                                            {item.label}
                                                        </OpenSansText>
                                                    </TouchableOpacity>
                                                )}
                                                {data && i < data.length - 1 && <Divider style={styles.divider} />}
                                            </View>
                                        ))}
                                </CustomScrollview>
                            </View>
                        </View>
                    </View>
                </Modal>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    containerModal: {
        position: "absolute",
        bottom: -20,
        alignSelf: "center",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        backgroundColor: "white",
        width: width - 40
    },
    itemContainer: { alignItems: "center", flexDirection: "row" },
    divider: { height: 1, backgroundColor: baseColors.green.primary }
})
